import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ManualAddressDto } from '@shared/src/controllers/maps/ManualAddressDto';

@Component({
    selector: 'shared-shipment-item-address-maintenance',
    templateUrl: './shared.shipment.item.address.maintenance.component.html',
    styleUrls: ['./shared.shipment.item.address.maintenance.component.scss']
})
export class SharedShipmentItemAddressMaintenanceComponent {

    @Input() public type: string = "";
    @Input() public titleCaption: string = "";
    @Input() public addresses: ManualAddressDto[] | null = null;
    @Input() public skinAddress: string = "";
    @Input() public descriptionShort: string = "";
    @Input() public formattedAddress: string = "";

    @Output() public markerDoubleClick: EventEmitter<string> = new EventEmitter();
    @Output() public manualAddressMarkerDoubleClick: EventEmitter<ManualAddressDto> = new EventEmitter();
}
